import { flyGaLogic } from '../../listings-client/util/flyGaLogic'

const logHelper = (category, action, label) => {
  flyGaLogic.fire.logUpsellTray({
    category: category,
    action: action,
    label: label,
  })
}

const logUpsellTrayDisplay = (tripType) => {
  logHelper('bf-add-on', 'card-cta-display', tripType)
}

const logClickShowAddon = (itineryPosition) => {
  logHelper('bf-add-on', 'expand', itineryPosition)
}

const logClickTile = (tilePosition) => {
  logHelper('bf-add-on', 'tile-click', tilePosition)
}

const logGetAirlineAndFB = (airline, farebrand) => {
  logHelper('bf-add-on', farebrand, airline)
}

const logTileCount = (tileNum) => {
  logHelper('bf-add-on', 'tray-load-count', tileNum)
}

export {
  logUpsellTrayDisplay,
  logClickShowAddon,
  logClickTile,
  logGetAirlineAndFB,
  logTileCount,
}
